import { IA11yModule } from "./A11yModule.types";

declare const A11yModule: IA11yModule;
